import React from 'react';
import { ActivityImage } from './ActivityImage';
import { ActivityInfo, ActivityType } from '../ActivityInfo/ActivityInfo';
import { Body1Bold } from '../../config/designSystem/typography';
import { HEIGHT_ACTIVITY_FN, WIDTH_ACTIVITY_FN } from '../../config/designSystem/Layout';
import { SPACING } from '../../config/designSystem/Spacing';
import { TouchableOpacity, View } from 'react-native';
import { contentTypeForActivityItem } from '../../types/types';
import { useAvailableDimensions } from '../../hooks/ui/useAvailableDimensions';
import { useContentInfo } from '../../hooks/content/useContentInfo';

type ActivityCardProp = {
  id: string;
  contentType: contentTypeForActivityItem;
  showActivityType?: boolean;
};

export const ActivityCard = ({ id, contentType, showActivityType }: ActivityCardProp) => {
  const { width } = useAvailableDimensions();

  const WIDTH_ACTIVITY = WIDTH_ACTIVITY_FN(width);
  const HEIGHT_IMAGE = HEIGHT_ACTIVITY_FN(width);

  const { title, activityType, onPress } = useContentInfo(id, contentType);

  return (
    <TouchableOpacity
      onPress={onPress}
      style={{
        rowGap: SPACING['sp-8'],
      }}
    >
      <ActivityImage id={id} width={WIDTH_ACTIVITY} height={HEIGHT_IMAGE} contentType={contentType} />
      <View style={{ rowGap: SPACING['sp-4'], maxWidth: WIDTH_ACTIVITY }}>
        <Body1Bold>{title}</Body1Bold>
        {!!activityType && showActivityType && <ActivityInfo type={activityType as ActivityType} />}
      </View>
    </TouchableOpacity>
  );
};
